import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { Link } from 'react-router-dom';
import { SystemText } from '@salesperformanceint/e4shared';
import { hasModule } from 'helpers/profile';
import { adminMenus } from 'components/asideRight/components/adminMenu/adminMenu';
import config from '../../config';
import PageHeader from 'components/general/pageHeader';
import './admin.css';
import { setPrismMenu } from 'actions/ui';

export const Admin = () => {
    const dispatch = useDispatch();
    const user = useSelector(state => state.user.user);
    const hasMetrics = user.crmIntegration || user.integrations?.filter(i => i.data_Integration).length > 0;
    const [menus, setMenus] = React.useState([]);

    React.useEffect(() => {
        dispatch(setPrismMenu('Admin'));
    }, []);

    React.useEffect(() => {
        const temp = ([...adminMenus] || []).reduce((all, m) => {
            const parent = { ...m };
            const isLearn2Enabled = !!user?.companySettings?.isLearn2;
            
            parent.children = m.children
                ? [...m.children]
                      .filter(c => isLearn2Enabled || !Array.isArray(c.features) || !c.features.includes('learn2'))
                      .filter(c => user.support || !c.features?.includes('partner'))
                      .filter(c => !c.module || hasModule(user, c.module))
                : null;

            return !m.module || hasModule(user, m.module) ? all.concat([parent]) : all;
        }, []);
        setMenus(temp);
    }, [user?.companySettings?.modules]);

    const tabIndex = 40;

    const childMenus = kids => {
        return (
            <div>
                <div className="mt20">
                    {kids.map((child, index) => {
                        if (child.switch && !config.switches[child.switch]) return null;
                        if (child.companySetting && !child.companySetting(user.companySettings)) return null;
                        if (child.metricsOnly && !hasMetrics) return null;
                        const label = SystemText(`Admin/Menu/${child.ref}/Title`);
                        return (
                            <Link
                                tabIndex={tabIndex}
                                key={index}
                                data-testid={`submenu-right-${child.ref?.toLowerCase()}`}
                                className="admin-link"
                                to={`/admin${child.route}`}
                                aria-label={`Navigate to ${label}`}
                            >
                                <div>{label}</div>
                                <p>{SystemText(`Admin/Menu/${child.ref}/Description`)}</p>
                            </Link>
                        );
                    })}
                </div>
            </div>
        );
    };

    return (
        <div>
            <PageHeader title="Administration" />
            <div className="admin-menu">
                {menus.map((menu, index) => {
                    if (menu.switch && !config.switches[menu.switch]) return null;
                    return (
                        <>
                            <div
                                key={`menu-right-${index}`}
                                data-testid={`menu-${menu.ref?.toLowerCase()}`}
                                className="admin-menu-item"
                            >
                                <div className="box">
                                    <div className="text-center">
                                        <i className={`fa fa-lg ${menu.icon}`} />
                                    </div>
                                    <div>{childMenus(menu.children)}</div>
                                </div>
                            </div>
                        </>
                    );
                })}
            </div>
        </div>
    );
};

export default Admin;
